import { GroupMemberSignUpMethod } from '@group/domain/GroupEntity/GroupMemberSignUpMethod';
import { SignUpMethodMenu } from '../GroupMemberInvitationPage/UnauthenticatedMenu/SignUpMethodMenu';
import { SimpleFooterLayout } from '@user/layouts/SimpleFooterLayout';
import BalusLogo from '@assets/balus-logo-brand-horizontal.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router';
import { UserPagePathBuilder } from '../UserPagePathBuilder';
import { useLoginErrorMessage } from '@user/Login';
import { Trans, useTranslation } from 'react-i18next';

type ExternalLinkProps = { href: string; children?: React.ReactNode };
const ExternalLink: React.FC<ExternalLinkProps> = ({ href, children }: ExternalLinkProps) => (
  <a href={href} target="_blank" rel="noreferrer" className="text-blue-700 underline hover:text-blue-800">
    {children} <FontAwesomeIcon icon={faExternalLinkAlt} />
  </a>
);

export const Entry: React.FC<unknown> = () => {
  const { t } = useTranslation();
  const availableSignUpMethods = GroupMemberSignUpMethod.buildNew();
  const navigate = useNavigate();
  const loginErrorMessage = useLoginErrorMessage();

  const onLogin = () => {
    navigate(UserPagePathBuilder.loginPage());
  };

  return (
    <SimpleFooterLayout>
      <div className="flex w-screen flex-col items-center p-8">
        <img src={BalusLogo} className="w-64" />
        <div className="pb-4 pt-8 text-3xl font-bold">{t('home.entry.heading')}</div>
        <div className="pb-4 text-sm text-gray-700">{t('home.entry.freeDescription')}</div>

        <div className="flex flex-col rounded-lg border border-gray-500 p-8" style={{ width: '600px' }}>
          <div className="flex flex-col items-center py-4">
            {loginErrorMessage && <div className="py-4 text-red-700">{loginErrorMessage}</div>}

            <SignUpMethodMenu availableSignUpMethods={availableSignUpMethods} onLogin={onLogin} />

            <div className="pt-8 text-sm text-gray-700">
              <Trans
                i18nKey="home.entry.terms"
                components={{
                  termsLink: <ExternalLink href="https://levii.co.jp/legal/terms-of-service/" />,
                  privacyLink: <ExternalLink href="https://levii.co.jp/legal/privacy-policy/" />,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </SimpleFooterLayout>
  );
};
